export const ADD_ROLES_DATA = "ADD_ROLES_DATA"
export const ADD_HEIRARACHY_CHART = "ADD_HEIRARACHY_CHART"
export const FETCH_USERS = 'FETCH_USERS'
export const SET_HEIRARACHY_LOADING = 'SET_HEIRARACHY_LOADING'
export const FETCH_HEIRARACHY_CHART = 'FETCH_HEIRARACHY_CHART'
export const EDIT_HEIRARACHY_CHART = 'EDIT_HEIRARACHY_CHART'
export const DELETE_HEIRARACHY_CHART = 'DELETE_HEIRARACHY_CHART'
export const FETCH_ROLE_USERS = 'FETCH_ROLE_USERS'